import * as React from 'react';
export const PGSvg = React.forwardRef(function PGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M14.005 2A2 2 0 0 1 16 3.992v8.016A1.994 1.994 0 0 1 14.005 14H2a2 2 0 0 1-2-2V3.992C0 2.893.893 2 1.995 2h12.01Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M15.328 13.496A1.992 1.992 0 0 1 14 14H1.994C.894 14 0 13.1 0 11.991V4c0-.595.26-1.13.672-1.496l14.656 10.992Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M3 12.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2-4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-3 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1-3a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F4B32E',
        d: 'M11 5V3.708c0-.557.353-.75.805-.418l2.89 2.12c.445.326.357.59-.194.59H12v1.506c0 .536-.35.721-.784.384L8.284 5.61c-.43-.335-.337-.61.215-.61H11Z',
      }),
    ),
  );
});
PGSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PG = {
  category: 'flag',
  colorable: false,
  name: 'PG',
  svg: PGSvg,
};
